module.exports = __webpack_public_path__ + "static/img/cover.bd4bd3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/2/cover.jpg
// module id = MLT6
// module chunks = 27